/**
 * Um cartao da tela inicial, contribuido por um plugin.
 *
 * A casca desenha a moldura e nao sabe o que la vai dentro (regra 1). Se o
 * widget quebrar, quebra so ele: os outros cartoes continuam na tela.
 */
import { Suspense, lazy, useMemo, type ComponentType } from 'react';
import { Spinner } from '@flos/ui';
import type { RegisteredWidget } from '@flos/core';
import { PluginErrorBoundary } from './PluginErrorBoundary';

export interface WidgetSlotProps {
  widget: RegisteredWidget;
  /** Nome do plugin em portugues, para a mensagem de erro nomear a origem. */
  pluginName: string;
  onError?: (error: Error) => void;
}

export function WidgetSlot({ widget, pluginName, onError }: WidgetSlotProps) {
  // `lazy` tem de ser criado uma so vez por widget, senao cada render descarta o
  // componente e o cartao pisca.
  const Loaded = useMemo<ComponentType<unknown>>(
    () => lazy(widget.component),
    [widget.component],
  );

  return (
    <section className="app-widget" aria-label={widget.title}>
      <PluginErrorBoundary
        pluginName={pluginName}
        {...(onError ? { onError: (error: Error) => onError(error) } : {})}
      >
        <Suspense fallback={<Spinner label={`Abrindo ${widget.title}…`} />}>
          <Loaded />
        </Suspense>
      </PluginErrorBoundary>
    </section>
  );
}
